import { render } from "./StudentEventsPage.vue?vue&type=template&id=00ee3124&scoped=true&ts=true"
import script from "./StudentEventsPage.vue?vue&type=script&lang=ts"
export * from "./StudentEventsPage.vue?vue&type=script&lang=ts"

import "./StudentEventsPage.vue?vue&type=style&index=0&id=00ee3124&lang=postcss&scoped=true"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ee3124"]])

export default __exports__